/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const CHECK_APPLE_PAY_ENABLED = 'MFE/CHECKOUT/CHECK/APPLE/PAY/ENABLED';

export default {};
